import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import jwtDecode from 'jwt-decode';
import { z } from 'zod';

import { queryFleetMembers } from 'src/api/queries/fleet';
import type { RmClaims } from 'src/api/queries/user';
import { EnterpriseMembersPage } from 'src/apps/fleet/app/FleetApp';
import { authHelpers } from 'src/utils/authHelpers';
import { AccessDeniedError } from 'src/utils/errors';
import { userHelpers } from 'src/utils/userHelpers';

const defaultValues = {
  filter: '',
  member: '',
  devices: [],
  integrations: [],
  roles: [],
  type: [],
  status: [],
  'device-software-versions': [],
  beta: [],
};

const routeSearchSchema = z.object({
  member: z.string().default(defaultValues.member),
  invite_by: z.enum(['email']).optional(),
  filter: z.string().default(defaultValues.filter),
  devices: z.array(z.string()).default(defaultValues.devices),
  integrations: z.array(z.string()).default(defaultValues.integrations),
  roles: z.array(z.string()).default(defaultValues.roles),
  type: z.array(z.string()).default(defaultValues.type),
  status: z.array(z.string()).optional(),
  'device-software-versions': z
    .array(z.string())
    .default(defaultValues['device-software-versions']),
  beta: z.array(z.string()).default(defaultValues.beta),
});
export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/members'
)({
  validateSearch: zodValidator(routeSearchSchema),
  search: { middlewares: [stripSearchParams(defaultValues)] },
  async beforeLoad({ context }) {
    const auth = await context.auth;

    if (!auth.user) {
      throw redirect({ to: '/login' });
    }

    const accessToken = await authHelpers.getAccessTokenSilently(auth);
    const claims = jwtDecode<RmClaims>(accessToken);

    if (!userHelpers.hasPermissionReadMembers(claims)) {
      throw new AccessDeniedError(
        'You do not have permission to view this page. Please contact your IT admin to request access.'
      );
    }
  },
  loader({ context }) {
    void context.queryClient.ensureQueryData(queryFleetMembers());
  },
  component: () => <EnterpriseMembersPage />,
});
